import { useEmployeeRepository } from '../repositories';

export function useEmployees(variables?: { page?: number; perPage?: number; search?: string; status?: string }) {
  const repo = useEmployeeRepository();
  return repo.useList(variables);
}

export function useEmployee(id: string) {
  const repo = useEmployeeRepository();
  return repo.useGet(id);
}

export function useCreateEmployee() {
  const repo = useEmployeeRepository();
  const { create, loading, error } = repo.useCreate();
  return {
    mutate: (input: any) => create(input),
    mutateAsync: (input: any) => create(input),
    isPending: loading,
    loading,
    error,
  };
}

export function useUpdateEmployee() {
  const repo = useEmployeeRepository();
  const { update, loading, error } = repo.useUpdate();
  return {
    mutate: (vars: { id: string; input: any }) => update(vars.id, vars.input),
    mutateAsync: (vars: { id: string; input: any }) => update(vars.id, vars.input),
    isPending: loading,
    loading,
    error,
  };
}
